export var ITEM_NAVIGATION_MODE = 'item';
export var CATEGORY_NAVIGATION_MODE = 'category';